import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http, money, pct, SITE } from "@/lib/api";
import { Download } from "lucide-react";

export const TickerBadge = ({ ticker, brand, className = "h-12" }) => {
  const [failed, setFailed] = useState(false);
  const file = brand === "High Income Shares" ? ticker : ticker.split(".")[0];
  if (failed) {
    return <span className={`inline-flex items-center bg-hv-navy px-2 font-heading text-sm font-bold text-white ${className}`}>{ticker}</span>;
  }
  return <img src={`/brand/badges/${file}.svg`} alt={`TSX: ${ticker}`} className={`w-auto ${className}`} onError={() => setFailed(true)} />;
};

export const useFund = (ticker) => {
  const [card, setCard] = useState(null);
  useEffect(() => {
    if (!ticker) return;
    http.get(`/funds/${ticker}`).then((r) => setCard(r.data)).catch(() => setCard(false));
  }, [ticker]);
  return card;
};

export const FeaturedCard = ({ ticker, internal }) => {
  const card = useFund(ticker);
  if (!card) return <div className="h-[340px] animate-pulse bg-white" />;
  const c = card.classes[0];
  const base = card.base_ticker.toLowerCase();
  return (
    <article className="flex flex-col bg-white p-8 transition-shadow duration-300 hover:shadow-[0_12px_32px_rgba(24,52,87,0.12)]" data-testid={`featured-card-${base}`}>
      <TickerBadge ticker={c.ticker} brand={card.brand} />
      <h3 className="mt-6 min-h-[56px] font-heading text-lg font-bold leading-snug text-hv-text">{card.fund_name}</h3>
      <dl className="mt-4 grid grid-cols-2 border-y border-hv-rule py-4">
        <div><dt className="font-heading text-xs font-semibold uppercase tracking-wider text-hv-muted">Price</dt><dd className="font-heading text-2xl font-bold text-hv-navy">{money(c.market_price)}</dd></div>
        <div><dt className="font-heading text-xs font-semibold uppercase tracking-wider text-hv-muted">Yield</dt><dd className="font-heading text-2xl font-bold text-hv-navy">{c.current_yield_pct != null ? pct(c.current_yield_pct) : "—"}</dd></div>
      </dl>
      <p className="mt-2 text-xs text-hv-muted">As at {c.as_at} · end-of-day · Risk: {c.risk_rating}</p>
      <div className="mt-5 flex flex-col gap-2 font-heading text-[13px] font-semibold text-hv-logo-navy">
        {card.documents?.product_sheet && <a href={card.documents.product_sheet} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:underline"><Download size={14} aria-hidden="true" /> Product Sheet</a>}
        {card.documents?.etf_facts && <a href={card.documents.etf_facts} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 hover:underline"><Download size={14} aria-hidden="true" /> ETF Facts</a>}
      </div>
      <div className="mt-auto pt-6">
        {internal ? (
          <Link to={internal} className="hv-btn-light w-full" data-testid={`featured-learn-more-${base}`}>Learn more about {card.base_ticker}</Link>
        ) : (
          <a href={`${SITE}/etf/${base}/`} className="hv-btn-light w-full">Learn more about {card.base_ticker}</a>
        )}
      </div>
    </article>
  );
};
